module.exports = __webpack_public_path__ + "img/img7.e25a0e2f.png";